import "./Home.css";
import ProductCard from '../ProductCard/ProductCard';
import {useState, useEffect} from "react";
import {SyncLoader} from "react-spinners";

export default function Home() {

    const [products, setProducts] = useState();

    useEffect(() => {
        fetch("/backend/database.json", { cache: "no-store" })
            .then(response => {
                return response.json()
            })
            .then(data => {
                setProducts(data);
            })
    }, [])

    return (
        <>
            {
                products ?
                    <div id="productsContainer">
                        {Object.keys(products).map(key =>
                            products[key].map(item => (
                                <ProductCard key={item.id} product={item}/>
                            ))
                        )}
                    </div> :
                    <SyncLoader
                        className="dotLoader"
                        color="#ffffff"
                        size={12}
                    />
            }
        </>
    )
}